/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Prop, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import DynamicComponent from '@/mixins/DynamicComponent';

const namespace: string = 'settingsModule';

/**
 * Dynamic Eula component mixin.
 *
 * Extends the dynamic component mixin to provide eula dynamic inclusion.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component
export default class GuideComponent extends DynamicComponent {
    @Getter('language', {namespace}) public language!: string;
    public category!: string;

    @Watch('language')
    @Watch('category')
    public onConfigurationChanged(): void {
        this.component = this.loader();
    }

    /**
     * Template property getter.
     *
     * This should be overriden in component injection classes.
     *
     * @returns {string}
     *
     * @override
     */
    public get template(): string {
        const language: string = (this.language || 'en').toLowerCase();
        return `i18n/guide/${this.category}/${language}`;
    }

    /**
     * Fallback function that loads the default component.
     *
     * @returns {Promise<any>}
     *
     * @override
     */
    public fallback(): Promise<any> {
        return import(`@/i18n/guide/${this.category}/en.vue`);
    }
}

